import moment from 'moment'

const DATE_TYPES = [
  {
    format: 'MMMM Do YYYY, h:mm:ss a',
    keyNames: ['decision_at', 'soft_pull_at'],
  },
  {
    format: 'MMMM Do YYYY',
    keyNames: ['origination_date'],
  },
]

const DATES_KEY_NAMES: string[] = DATE_TYPES
  // Reduce all keynames that have the date value into one array
  .reduce<string[]>((total, currentValue) => {
    return [...total, ...currentValue.keyNames]
  }, [])

const isDate = (keyName) => DATES_KEY_NAMES.includes(keyName)

export const format = {
  date: (keyName, date) => {
    const getFormat = DATE_TYPES.find(({ keyNames }) =>
      keyNames.includes(keyName)
    )?.format
    return moment(date).format(getFormat)
  },
  string: (inputString) =>
    inputString
      .split('_')
      .map((word) => `${word}`.charAt(0).toUpperCase() + `${word}`.slice(1))
      .join(' '),
  customKeyName: (string) => {
    const treatedNames = {
      adverse_actions: 'adverse_action',
      failed_rules: 'failed_rule',
      rule_waivers: 'rule_waiver',
      tradeline_overrides: 'tradeline_overrides',
      tradelines: 'tradeline',
    }

    if (treatedNames[string]) return treatedNames[string]

    return string
  },
  value: (keyName, value) => {
    if (typeof value === 'string') {
      if (isDate(keyName)) return format.date(keyName, value)
      return format.string(value)
    }
    if (typeof value === 'number') {
      return value
    }
    if (value === null) {
      return '-'
    }
    if (typeof value === 'boolean') {
      return format.string(value.toString())
    }
    return 'Unknown value'
  },
}
